<template>
    <b-modal ref="profile_modal" size="xl" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.doc.id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="p-4" v-if="!is_load">
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        ID
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" disabled type="text" class="form-control" v-model="doc.id">
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Назва
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" disabled type="text" class="form-control" v-model="doc.name">
                    </div>
                </div>
                
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Ради *
                    </label>
                </div>
                
                <b-table head-variant="dark"
                         thead-class="dark"
                         :busy="is_load"
                         striped
                         class="table-responsive-xl resolution_table"
                         :items="doc.attached_radu"
                         :fields="fields">
                    
                        <template  v-slot:cell(name)="data" >
                            <div v-if="parseInt(data.item.id) > 0">
                                {{data.item.name}}
                                <div class="small">
                                    Кількість паїв :<small>   {{data.item.attached_pai_count}}</small>
                                </div>
                            </div>
                            
                            <div v-else>
                                <input id="advanced_name"  type="text" class="form-control" v-model="data.item.name">
                            </div>
                        </template>
                    
                        <template  v-slot:cell(remove)="data" >
                            <div class="remove_new_item text-center" v-on:click="remove_item(data.item,data.index)">
                                <i class="fal fa-trash-alt fs-xl cursor-pointer color-danger-100"></i>
                            </div>
                        </template>
                    
                        <template  v-slot:cell(id)="data" >
                            <div class="id_cc" v-if="parseInt(data.item.id) > 0">
                                {{data.item.id}}
                            </div>
                            <div v-else>
                                <span class="badge">
                                    new
                                </span>
                            </div>
                        </template>
                </b-table>
                
                <table class="mt-3">
                    <tfoot>
                        <tr>
                            <td>
                                <div id="add_rada" class="btn  btn-outline-warning   waves-effect waves-themed" title="" v-on:click="new_rada">Додати</div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed">
                    Закрити
                </button>
                
                <button type="button" v-on:click="save_doc" class="btn btn-primary waves-effect waves-themed">
                    Зберегти
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script >

export default {
    name: "sb_doc_edit",
    
    created() {
        EventBus.$on("edit_rada", this.edit_doc);
    },
    
    data() {
        return {
            modal_position: "right",
            is_show_modal: false,
            is_load: false,
            doc: {
                id: 0,
                attached_radu : [],
                
            },
            
            fields : [
                {
                    key : 'id',
                    label: 'ID',
                    class:'id'
                },
                
                {
                    key : 'name',
                    label: 'Назва',
                    class:'user_td_name'
                },
                
                {
                    key : 'remove',
                    label: '',
                    class:''
                },
            ],
        }
    },
    
    methods: {
        
        close_modal() {
            this.close();
        },
        
        close() {
            this.doc = this.default_item;
            this.is_show_modal = false;
        },
        
        edit_doc(doc_id) {
            this.load_item(doc_id);
        },
        
        new_rada() {
            this.doc.attached_radu.push({
                "id" : 0,
                "name" : "",
                "attached_pai_count" : 0
            })
        },
        
        
        remove_item(item,idx) {
            let id = parseInt(item.id);
            if(id > 0) {
                this.remove_item_api(id);
            }
            this.doc.attached_radu.splice(idx,1);
        },
        
        async remove_item_api(id) {
            await api.delete('/selo/rada/' + id).then(({data}) => {
                if (data.status === "operation_success") {
                    this.doc = data.data;
                }
            }).catch(err => {
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
            .finally(() => {
                IMC_CORE.hideloading();
                this.is_load = false;
            });
        },
        
        async load_item(id) {
            this.is_load = true;
            this.doc = this.default_item;
            IMC_CORE.showloading();
            await api.get('/selo/' + id).then(({data}) => {
                this.is_show_modal = true;
                if (data.status === "operation_success") {
                    this.doc = data.data;
                }
            }).catch(err => {
                console.log(err);
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
                .finally(() => {
                    IMC_CORE.hideloading();
                    this.is_load = false;
                });
        },
        
        async save_doc() {
            await api.put('/selo/' + this.doc.id,this.doc).then(({data}) => {
                if (data.status === "operation_success") {
                    this.doc = data.data;
                }
            }).catch(err => {
                console.log(err);
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
            .finally(() => {
                IMC_CORE.hideloading();
                this.is_load = false;
            });
        }
        
    },
    
    computed: {
        default_item() {
            return {
                id: 0,
            }
        },
        
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-xl";
            }
            
            return "modal-dialog-right modal-xl";
        },
    }
}
</script>


<style scoped>

</style>